module.exports = __webpack_public_path__ + "img/connect.421c9701.png";